import React, { useEffect, useState, useCallback, useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  CircularProgress,
  Box,
} from "@material-ui/core";

import { useStyles } from "./styles";

const HUBSPOT_SCRIPT_SRC = "https://js.hsforms.net/forms/embed/50794376.js";
const HUBSPOT_PORTAL_ID = "50794376";
const HUBSPOT_FORM_ID = "33c7e66a-1d45-4674-bf03-2744ebe99816";
const HUBSPOT_REGION = "na1";

const ModalHubspot = ({ titulo, visivel, setVisivel }) => {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const openCountRef = useRef(0);

  // Carrega o script do HubSpot apenas uma vez
  const loadHubspotScript = useCallback(() => {
    if (scriptLoaded) return;

    if (document.querySelector(`script[src="${HUBSPOT_SCRIPT_SRC}"]`)) {
      setScriptLoaded(true);
      return;
    }

    const script = document.createElement("script");
    script.src = HUBSPOT_SCRIPT_SRC;
    script.defer = true;
    script.onload = () => {
      setScriptLoaded(true);
    };
    script.onerror = () => {
      console.error("Erro ao carregar script do HubSpot");
      setIsLoading(false);
    };

    document.body.appendChild(script);
  }, [scriptLoaded]);

  // Carrega o script quando o componente monta
  useEffect(() => {
    loadHubspotScript();
  }, [loadHubspotScript]);

  // Marca o formulário como pronto assim que o HubSpot avisa via postMessage
  useEffect(() => {
    const handleHubspotMessage = (event) => {
      if (
        event.data?.type === "hsFormCallback" &&
        event.data?.eventName === "onFormReady"
      ) {
        setIsLoading(false);
      }
    };

    window.addEventListener("message", handleHubspotMessage);
    return () => window.removeEventListener("message", handleHubspotMessage);
  }, []);

  // Exibe o loading a cada abertura do modal (o script do HubSpot renderiza o formulário sozinho)
  useEffect(() => {
    if (visivel && scriptLoaded) {
      openCountRef.current += 1;
      setIsLoading(true);
    }
  }, [visivel, scriptLoaded]);

  return (
    <Dialog
      key="modal-hubspot"
      open={visivel}
      onClose={() => setVisivel(false)}
      maxWidth="md"
      fullWidth
      className={classes.dialog}
    >
      <DialogTitle className={classes.dialogTitle}>
        <Typography variant="h6" component="h4">
          {titulo}
        </Typography>
      </DialogTitle>

      <DialogContent className={classes.dialogContent}>
        {isLoading && (
          <Box className={classes.loadingContainer}>
            <CircularProgress />
            <Typography variant="body2">Carregando formulário...</Typography>
          </Box>
        )}

        <Box className={classes.formContainer}>
          <Box
            key={`hubspot-form-${openCountRef.current}`}
            className={`hs-form-frame ${classes.formContent}`}
            data-region={HUBSPOT_REGION}
            data-form-id={HUBSPOT_FORM_ID}
            data-portal-id={HUBSPOT_PORTAL_ID}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ModalHubspot;
